// LanguageContext.js
import React, { createContext, useState, useEffect } from 'react';

// Create the context
export const LanguageContext = createContext();

// Create the provider component
export const LanguageProvider = ({ children }) => {
  // Initialize language state from localStorage or default to 'en'
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'id');

  // Update localStorage whenever the language changes
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Toggle between English ('en') and Indonesian ('id')
  const toggleLanguage = () => {
    setLanguage((prevLanguage) => (prevLanguage === 'id' ? 'en' : 'id'));
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
